import { ToastContainerProps } from "react-toastify";
import { WhatsappWebHookStatusEntity } from "../../../utils/enum";

export const TRUST_SEAL_IMAGE_BASE = '/assets/images/trust-seal'


export const DEFAULT_FILTER_FOR_VIEW_TRUST_SEAL = {
    pageNumber: 0,
    pageSize: 10,
    orderNumber: "",
    mobileNo: "",
    sortBy: "qrScanDateFilter",
    sortOrder: -1,
    scanDateFrom: "",
    scanDateTo: "",
    scanTimeFrom: "",
    scanTimeTo: "",
    status: [],
    whatsappStatus: [],
    isOTPVerified: []
}


export const TrustSealStorageKey = 'trustSealQaProcessed';


export const toastTrustSealOptObj: ToastContainerProps = {
    position: "top-center",
    autoClose: 3500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    className: "jb-toast",
    bodyClassName: "jb-toast-body",
    progressClassName: "jb-toast-progress",
};


export const trustSealWhatsappStatusOptions = [
    { label: "Delivered", value: WhatsappWebHookStatusEntity.DELIVERED },
    { label: "Failed", value: WhatsappWebHookStatusEntity.FAILED },
    { label: "Sent", value: WhatsappWebHookStatusEntity.SENT },
    { label: "Read", value: WhatsappWebHookStatusEntity.READ },
];

export const otpVerifiedOptions = [
    { label: "YES", value: "YES" },
    { label: "NO", value: "NO" },
];

export const statusOptions = [
    { label: "Valid", value: "Valid" },
    { label: "Invalid", value: "Invalid" },
];
